/**
 * Checkout Redirect Functions
 *
 * Handles redirects to checkout and subscription management pages
 * @module portal/modules/ui/modals/checkoutRedirect
 */

/**
 * Redirect to the checkout page
 */
export async function openCheckoutModal(): Promise<void> {
  window.location.href = '/signup';
}

/**
 * Redirect to the subscription management page
 */
export async function openManageSubscription(): Promise<void> {
  window.location.href = '/signup';
}
